/**
 * New Angance Skin Diagnostic Quiz — Bilingual (FR / EN)
 * Flow: intro -> questions (auto-advance 400ms) -> email gate -> result
 * Language is read from data-language on #quizApp, set by Shopify locale.
 * UI strings come from window.quizTranslations injected by quiz-page.liquid.
 */
class QuizEngine {
  constructor() {
    this.app = document.getElementById("quizApp");
    this.lang = (this.app.dataset.language || "fr").startsWith("fr") ? "fr" : "en";
    this.t = window.quizTranslations || {};
    this.questions = QuizData;
    this.answers = {};
    this.routine = null;
    this.rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    this.allProductsUrl = this.app.dataset.allProductsUrl || (this.rootUrl + "collections/all");
    this.cartUrl = this.app.dataset.cartUrl || (this.rootUrl + "cart");
  }

  // Helper: get translated field from a question/option using translations object
  _tr(obj) {
    return obj.translations ? obj.translations[this.lang] : obj;
  }

  _label(key, fallback) { return this.t[key] || fallback || key; }

  _escape(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  init() { this.renderIntro(); }

  // ─────────────────────────────────────────────────────────────────────────
  // INTRO
  // ─────────────────────────────────────────────────────────────────────────
  renderIntro() {
    var introTitle = this._label("intro_title", "Your personalised") + "<br><em>" + this._label("intro_emphasis", "skin diagnostic") + "</em>";
    var introSub = this._label("intro_subtitle", "Answer a few questions to discover your ideal skincare ritual.");
    var introBtn = this._label("start", "Start the diagnostic");
    var introHint = this._label("duration", "2 minutes — 5 questions");
    var startButtonHtml =
      '<button type="button" class="quiz-button primary quiz-button-icon" data-quiz-start>' +
      introBtn +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"/></svg>' +
      '</button>';

    this.app.innerHTML =
      '<div class="quiz-intro quiz-fade-in">' +
      '<div class="quiz-intro-content">' +
      '<div class="quiz-logo-wrap">' +
      '<img src="https://newangance.com/cdn/shop/files/logo_new_angance.png?v=1757334236&width=600" alt="New Angance" class="quiz-logo"/>' +
      '</div>' +
      '<h1 class="quiz-intro-title">' + introTitle + '</h1>' +
      '<p class="quiz-intro-subtitle">' + introSub + '</p>' +
      '<div class="quiz-intro-actions quiz-intro-actions--desktop">' +
      startButtonHtml +
      '<p class="quiz-intro-hint">' + introHint + '</p>' +
      '</div>' +
      '</div>' +
      '<div class="quiz-intro-image" aria-hidden="true">' +
      '<img src="https://cdn.shopify.com/s/files/1/0963/8474/5736/files/Creme_Hydratation.png?v=1776081261" alt=""/>' +
      '</div>' +
      '<div class="quiz-intro-actions quiz-intro-actions--mobile">' +
      startButtonHtml +
      '<p class="quiz-intro-hint">' + introHint + '</p>' +
      '</div>' +
      '</div>';

    this.app.querySelectorAll("[data-quiz-start]").forEach((button) => {
      button.addEventListener("click", () => { this.goToQuestion(0); });
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // QUESTION
  // ─────────────────────────────────────────────────────────────────────────
  renderQuestion(index) {
    var question = this.questions[index];
    var tr = this._tr(question);
    var total = this.questions.length;
    var progress = ((index + 1) / total) * 100;
    var backLabel = this._label("back", "Back");
    var stepLabel = this._label("step", "Step") + " " + question.step;
    var ofLabel = " " + this._label("of", "of") + " ";

    var optionsHtml = question.options.map(opt => {
      var otr = this._tr(opt);
      var isSel = this.answers[question.id] === opt.id;
      var checkSvg = '<svg width="10" height="10" viewBox="0 0 20 20" fill="white"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>';
      return (
        '<button type="button" class="quiz-option' + (isSel ? ' selected' : '') + '" data-option="' + opt.id + '">' +
        '<span class="quiz-option-radio">' + (isSel ? checkSvg : '') + '</span>' +
        '<span class="quiz-option-text">' +
        '<span class="quiz-option-title">' + otr.label + '</span>' +
        (otr.description ? '<span class="quiz-option-description">' + otr.description + '</span>' : '') +
        '</span>' +
        '</button>'
      );
    }).join("");

    this.app.innerHTML =
      '<div class="quiz-question-screen quiz-fade-in">' +
      '<div class="quiz-header">' +
      '<div class="quiz-progress-info">' +
      '<span class="quiz-step-text">' + (index + 1) + ofLabel + total + '</span>' +
      '<div class="quiz-enso-progress" aria-hidden="true">' +
      '<svg width="32" height="32" viewBox="0 0 32 32" style="transform:rotate(-90deg)">' +
      '<circle cx="16" cy="16" r="13" fill="none" stroke="#e5e5e5" stroke-width="1"/>' +
      '<circle cx="16" cy="16" r="13" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="' + (progress * 0.817).toFixed(1) + ' 100" class="quiz-progress-arc"/>' +
      '</svg>' +
      '</div>' +
      '</div>' +
      // '<img src="https://newangance.com/cdn/shop/files/logo_new_angance.png?v=1757334236&width=600" alt="New Angance" class="quiz-header-logo"/>' +
      '</div>' +
      '<div class="quiz-header-bar"><div class="quiz-header-bar-fill" style="width:' + progress + '%"></div></div>' +
      '<div class="quiz-body">' +
      '<div class="quiz-question-wrap">' +
      '<p class="quiz-step-label">' + stepLabel + '</p>' +
      '<h2 class="quiz-title">' + tr.title + '</h2>' +
      (tr.subtitle ? '<p class="quiz-description">' + tr.subtitle + '</p>' : '') +
      '<div class="quiz-options" id="quizOptions">' + optionsHtml + '</div>' +
      '<button id="quizBackBtn" class="quiz-back-btn quiz-question-back" type="button">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"/></svg>' +
      '<span>' + backLabel + '</span>' +
      '</button>' +
      '</div>' +
      '</div>' +
      '</div>';

    document.getElementById("quizBackBtn").addEventListener("click", () => {
      if (index === 0) { this.renderIntro(); } else { this.goToQuestion(index - 1); }
    });

    document.getElementById("quizOptions").addEventListener("click", (e) => {
      var btn = e.target.closest(".quiz-option");
      if (!btn) return;
      this.selectOption(question.id, btn.dataset.option, index);
    });
  }

  selectOption(questionId, optionId, questionIndex) {
    this.answers[questionId] = optionId;
    var checkSvg = '<svg width="10" height="10" viewBox="0 0 20 20" fill="white"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>';

    document.querySelectorAll(".quiz-option").forEach(b => b.classList.remove("selected"));
    var sel = document.querySelector('.quiz-option[data-option="' + optionId + '"]');
    if (sel) {
      sel.classList.add("selected");
      var radio = sel.querySelector(".quiz-option-radio");
      if (radio) radio.innerHTML = checkSvg;
    }

    setTimeout(() => {
      if (questionIndex < this.questions.length - 1) {
        this.goToQuestion(questionIndex + 1);
      } else {
        this.routine = getRecommendation(this.answers, this.lang);
        this.renderEmailGate();
      }
    }, 400);
  }

  goToQuestion(index) {
    this.renderQuestion(index);
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // EMAIL GATE
  // ─────────────────────────────────────────────────────────────────────────
  renderEmailGate() {
    var t = this.t;
    var readyLabel = this._label("ready", "Your diagnostic is ready");
    var gateTitle = this._label("gate_title", "Receive your personalised routine");
    var gateSub = this._label("gate_subtitle", "Enter your email to discover your tailored ritual.");
    var namePh = this._label("first_name", "Your first name (optional)");
    var emailPh = this._label("email", "Your email address");
    var submitLabel = this._label("receive_results", "Receive my routine");
    var skipLabel = this._label("skip_email", "See my results without email");
    var consentText = this._label("consent", "I agree to receive recommendations by email.");
    var rgpdText = this._label("privacy", "Your data is handled confidentially.");
    var checkSvg = '<svg width="10" height="10" viewBox="0 0 20 20" fill="white"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>';

    this.app.innerHTML =
      '<div class="quiz-email-screen quiz-fade-in">' +
      '<div class="quiz-email-wrap">' +
      '<div class="quiz-email-icon" aria-hidden="true">' +
      '<svg width="40" height="40" viewBox="0 0 24 24" fill="none">' +
      '<path d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2Z" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-dasharray="2 3"/>' +
      '<path d="M8 12.5L10.5 15L16 9" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</div>' +
      '<p class="quiz-gate-label">' + readyLabel + '</p>' +
      '<h2 class="quiz-title">' + gateTitle + '</h2>' +
      '<p class="quiz-description">' + gateSub + '</p>' +
      '<form id="quizEmailForm" class="quiz-email-form">' +
      '<input type="text" id="quizName" placeholder="' + namePh + '" autocomplete="given-name"/>' +
      '<input type="email" id="quizEmail" placeholder="' + emailPh + '" required autocomplete="email"/>' +
      '<div id="quizEmailError" class="quiz-email-error" style="display:none"></div>' +
      '<label class="quiz-consent-label">' +
      '<span id="quizConsentBox" class="quiz-consent-box quiz-consent-checked" aria-checked="true" role="checkbox" tabindex="0">' + checkSvg + '</span>' +
      '<span class="quiz-consent-text">' + consentText + '</span>' +
      '</label>' +
      '<button type="submit" class="quiz-button primary">' + submitLabel + '</button>' +
      '</form>' +
      '<div class="quiz-skip-wrap"><button type="button" id="quizSkipBtn" class="quiz-skip-btn">' + skipLabel + '</button></div>' +
      '<p class="quiz-rgpd">' + rgpdText + '</p>' +
      '</div>' +
      '</div>';

    var consentChecked = true;
    var consentBox = document.getElementById("quizConsentBox");
    consentBox.addEventListener("click", function () {
      consentChecked = !consentChecked;
      consentBox.classList.toggle("quiz-consent-checked", consentChecked);
      consentBox.setAttribute("aria-checked", String(consentChecked));
      consentBox.innerHTML = consentChecked ? checkSvg : "";
    });

    var errMsg = this._label("invalid_email", "Please enter a valid email address.");
    document.getElementById("quizEmailForm").addEventListener("submit", (e) => {
      e.preventDefault();
      var emailInput = document.getElementById("quizEmail");
      var errorDiv = document.getElementById("quizEmailError");
      if (!this._validEmail(emailInput.value)) {
        errorDiv.textContent = errMsg;
        errorDiv.style.display = "block";
        return;
      }
      errorDiv.style.display = "none";
      console.log("Quiz submission:", {
        name: document.getElementById("quizName").value.trim(),
        email: emailInput.value.trim(),
        consent: consentChecked,
        answers: this.answers,
        routine: this.routine ? this.routine.title : null
      });
      // this.renderResult();

      var submitBtn = document.querySelector("#quizEmailForm .quiz-button");
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = this._label("please_wait", "Please wait…"); }

      var payload = {
        email: emailInput.value.trim(),
        name: document.getElementById("quizName").value.trim() || undefined,
        consent: consentChecked,
        answers: this.answers,
        routineTitle: this.routine ? this.routine.title : undefined
      };

      this._submitLead(payload)
        .catch(function () { /* non-blocking — never prevent user from seeing result */ })
        .finally(() => { this.renderResult(); });
      // Optional: POST to endpoint
      // fetch("/apps/quiz/submit", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) }).catch(function(){});
    });
    document.getElementById("quizSkipBtn").addEventListener("click", () => { this.renderResult(); });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // RESULT
  // ─────────────────────────────────────────────────────────────────────────
  renderResult() {
    var r = this.routine;
    var diagLabel = this._label("diagnostic", "Your diagnostic");
    var needLabel = this._label("main_need", "Your skin's primary need");
    var reasonLabel = this._label("why_selected", "Why this ritual was selected");
    var routineHeading = this._label("recommended_routine", "Your recommended routine");
    var tipsHeading = this._label("application_tips", "Application tips");
    var restartLabel = this._label("restart", "Restart the diagnostic");
    var seeAllLabel = this._label("see_all", "See all products");
    var ctaHint = this._label("explore_more", "Want to explore other routines?");
    var loadingProducts = this._label("loading_products", "Checking current prices and availability…");

    var productsHtml = r.products.map((p, index) =>
      '<a href="' + this.rootUrl + 'products/' + encodeURIComponent(p.handle) + '" class="quiz-product-card is-loading" data-product-index="' + index + '" data-handle="' + this._escape(p.handle) + '">' +
      '<div class="quiz-product-img-wrap"><img src="' + p.image + '" alt="' + p.name + '" loading="lazy" class="quiz-product-img"/></div>' +
      '<div class="quiz-product-info">' +
      '<div class="quiz-product-meta">' +
      '<span class="quiz-product-category">' + p.category + '</span>' +
      '<span class="quiz-product-price" aria-live="polite">—</span>' +
      '</div>' +
      '<p class="quiz-product-name">' + p.name + '</p>' +
      '<p class="quiz-product-desc">' + p.description + '</p>' +
      '</div>' +
      '<svg class="quiz-product-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"/></svg>' +
      '</a>'
    ).join("");

    var tipsHtml = r.tips.map(tip =>
      '<li class="quiz-tip">' +
      '<span class="quiz-tip-dot" aria-hidden="true"><svg width="8" height="8" viewBox="0 0 16 16" fill="currentColor"><circle cx="8" cy="8" r="4"/></svg></span>' +
      '<span>' + tip + '</span>' +
      '</li>'
    ).join("");

    this.app.innerHTML =
      '<div class="quiz-result-screen quiz-fade-in">' +
      '<div class="quiz-result-summary">' +
      '<div class="quiz-result-hero">' +
      '<img src="' + r.image + '" alt="' + r.title + '" class="quiz-result-hero-img"/>' +
      '</div>' +
      '<div class="quiz-result-hero-text">' +
      '<p class="quiz-gate-label">' + diagLabel + '</p>' +
      '<h1 class="quiz-result-title">' + r.title + '</h1>' +
      '<div class="quiz-result-insight"><p class="quiz-result-kicker">' + needLabel + '</p><p class="quiz-result-subtitle">' + r.subtitle + '</p></div>' +
      '</div>' +
      '</div>' +
      '<div class="quiz-result-body">' +
      '<div class="quiz-result-reason"><p class="quiz-result-kicker">' + reasonLabel + '</p><p class="quiz-result-desc">' + r.description + '</p></div>' +
      '<div class="quiz-divider">' +
      '<span class="quiz-divider-line"></span>' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="quiz-divider-icon"><path d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2Z" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-dasharray="2 3"/></svg>' +
      '<span class="quiz-divider-line"></span>' +
      '</div>' +
      '<h2 class="quiz-section-title">' + routineHeading + '</h2>' +
      '<div class="quiz-products">' + productsHtml + '</div>' +
      '<div class="quiz-routine-summary" aria-live="polite">' +
      '<span>' + this._label("routine_total", "Routine total") + '</span>' +
      '<strong id="quizRoutineTotal">' + loadingProducts + '</strong>' +
      '</div>' +
      '<h3 class="quiz-section-title quiz-tips-title">' + tipsHeading + '</h3>' +
      '<ul class="quiz-tips">' + tipsHtml + '</ul>' +
      '<div class="quiz-result-cta">' +
      '<p class="quiz-cta-hint">' + ctaHint + '</p>' +
      '<div id="quizCartError" class="quiz-cart-error" role="alert" hidden></div>' +
      '<div class="quiz-cta-buttons">' +
      '<button id="quizShopRitualBtn" class="quiz-button primary" disabled>' + this._label("shop_ritual", "Shop the ritual") + '</button>' +
      '<button id="quizRestartBtn" class="quiz-button secondary">' + restartLabel + '</button>' +
      '<a href="' + this.allProductsUrl + '" class="quiz-button secondary">' + seeAllLabel + '</a>' +
      '</div>' +
      '</div>' +
      '<div class="quiz-result-footer">' +
      '<img src="https://newangance.com/cdn/shop/files/logo_new_angance.png?v=1757334236&width=600" alt="New Angance" class="quiz-footer-logo"/>' +
      '<p class="quiz-footer-tagline">' + this._label("footer_tagline", "Where Asian Ritual Meets French Elegance") + '</p>' +
      '</div>' +
      '</div>' +
      '</div>';

    document.getElementById("quizRestartBtn").addEventListener("click", () => {
      this.answers = {};
      this.routine = null;
      this.renderIntro();
    });

    document.getElementById("quizShopRitualBtn").addEventListener("click", () => { this._addRoutineToCart(); });
    this._hydrateRecommendationProducts();
  }

  _productUrl(handle) {
    return this.rootUrl + "products/" + encodeURIComponent(handle);
  }

  _formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(this.lang === "fr" ? "fr-FR" : "en-GB", {
        style: "currency",
        currency: currency || "EUR"
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + " " + (currency || "EUR");
    }
  }

  _hydrateRecommendationProducts() {
    var productRequests = this.routine.products.map((product) =>
      fetch(this._productUrl(product.handle) + ".js", { headers: { Accept: "application/json" } })
        .then((response) => {
          if (!response.ok) throw new Error("Product unavailable");
          return response.json();
        })
        .then((shopifyProduct) => {
          var variant = shopifyProduct.variants.find((item) => item.available);
          return Object.assign({}, product, {
            title: shopifyProduct.title || product.name,
            image: shopifyProduct.featured_image || product.image,
            priceCents: variant ? variant.price : null,
            variantId: variant ? variant.id : null,
            available: Boolean(variant)
          });
        })
        .catch(() => Object.assign({}, product, { available: false, priceCents: null, variantId: null }))
    );

    Promise.all([
      Promise.all(productRequests),
      fetch(this.rootUrl + "cart.js", { headers: { Accept: "application/json" } })
        .then((response) => response.ok ? response.json() : { currency: "EUR" })
        .catch(() => ({ currency: "EUR" }))
    ]).then(([products, cart]) => {
      this.availableProducts = products.filter((product) => product.available);
      var currency = cart.currency || "EUR";
      var total = 0;

      products.forEach((product, index) => {
        var card = this.app.querySelector('[data-product-index="' + index + '"]');
        if (!card) return;
        card.classList.remove("is-loading");
        card.href = this._productUrl(product.handle);
        var title = card.querySelector(".quiz-product-name");
        var image = card.querySelector(".quiz-product-img");
        var price = card.querySelector(".quiz-product-price");
        if (title) title.textContent = product.title;
        if (image && product.image) { image.src = product.image; image.alt = product.title; }
        if (product.available) {
          total += product.priceCents;
          if (price) price.textContent = this._formatMoney(product.priceCents, currency);
        } else {
          card.classList.add("is-unavailable");
          if (price) price.textContent = this._label("unavailable", "Currently unavailable");
        }
      });

      var totalElement = document.getElementById("quizRoutineTotal");
      if (totalElement) totalElement.textContent = this.availableProducts.length
        ? this._formatMoney(total, currency)
        : this._label("no_products", "No recommended products are currently available.");
      var shopButton = document.getElementById("quizShopRitualBtn");
      if (shopButton) shopButton.disabled = this.availableProducts.length === 0;
    });
  }

  _addRoutineToCart() {
    var button = document.getElementById("quizShopRitualBtn");
    var errorBox = document.getElementById("quizCartError");
    if (!button || !this.availableProducts || !this.availableProducts.length) return;

    button.disabled = true;
    button.textContent = this._label("adding_ritual", "Adding your ritual…");
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ""; }

    fetch(this.rootUrl + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: this.availableProducts.map((product) => ({ id: product.variantId, quantity: 1 }))
      })
    })
      .then((response) => {
        if (!response.ok) throw new Error("Cart request failed");
        window.location.assign(this.cartUrl);
      })
      .catch(() => {
        button.disabled = false;
        button.textContent = this._label("shop_ritual", "Shop the ritual");
        if (errorBox) {
          errorBox.textContent = this._label("cart_error", "We couldn't add the complete ritual. Please try again.");
          errorBox.hidden = false;
        }
      });
  }

  _submitLead(payload) {
    // tRPC batch input: { "0": { json: <input> } }
    var input = JSON.stringify({ "0": { json: payload } });
    var base = (window.quizApiBase || "").replace(/\/+$/, "");
    var url = base + "/api/trpc/leads.create?batch=1";

    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: input
    })
      .then(function (res) {
        // tRPC returns 200 even for errors; parse to surface them in console
        return res.json().then(function (data) {
          // data is an array (batch); data[0].result.data.json = { success: true }
          if (data && data[0] && data[0].error) {
            console.warn("[Quiz] Lead API error:", data[0].error);
          }
        });
      });
  }

  _validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
}

document.addEventListener("DOMContentLoaded", function () {
  var app = document.getElementById("quizApp");
  if (!app) return;
  var quiz = new QuizEngine();
  quiz.init();
});
